import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import { replaceWithJioCDN } from '../../../../../../utils/imageHandling';

const cx = classNames.bind(styles);

interface ElementSizeProps {
  width?: string;
  height?: string;
}
interface BannerProps {
  wrapperSize: ElementSizeProps;
  imageSize: ElementSizeProps;
  imageSrc: string;
  imageAlt: string;
  onClick: (PAGE_TYPE: string) => void;
}

const Banner = (props: BannerProps): JSX.Element | null => {
  const { wrapperSize = {}, imageSize = {}, imageSrc = '', imageAlt = '', onClick } = props;

  if (!imageSrc) return null;
  return (
    <div style={{ ...wrapperSize }} className={cx('banner-wrapper')} onClick={onClick}>
      <img style={{ ...imageSize }} className={cx('banner')} src={replaceWithJioCDN(imageSrc)} alt={imageAlt} />
    </div>
  );
};

export default Banner;
